import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import ErrorPage from "./pages/ErrorPage";
import AdminDashboardPage from "./AdminPage/JobsAdding";
import Login from "./LoginPage/login";
import JobDetail from "./JobDetail/JobDetail";
import JobList from "./components/JobList";
import HomeContent from "./components/HomeContent";
import Contact from "./pages/contact/Contact";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />{" "}
        <Route path="/homecontent" element={<HomeContent />} /> {" "}
        <Route path="/login" element={<Login />} />{" "}
        <Route path="/error" element={<ErrorPage />} />{" "}
        <Route path="/addjob" element={<AdminDashboardPage />} />{" "}
        <Route path="/joblist" element={<JobList />} />{" "}
        <Route path="/jobdetail" element={<JobDetail />} />{" "}
        <Route path="/contact" element={<Contact />} />{" "}

      </Routes>{" "}
    </BrowserRouter>
  );
}

export default App;
